import { IconSuccess16, Label, Tooltip, UIText2 } from '@cian/ui-kit';

import { type FC, useMemo } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';

import { TooltipContent } from '../../components/TooltipContent';

import { SuperAgentIcon } from './components/SuperAgentIcon';

export const FromSuperAgentLabelContainer: FC = () => {
  const { config } = useListingAppContext();
  const tooltipRaw = config.get<string>('moderation.QualityLevelTooltip');

  const tooltip = useMemo<string[] | null>(() => {
    return tooltipRaw ? tooltipRaw.split(',') : null;
  }, [tooltipRaw]);

  const label = useMemo(
    () => (
      <Label
        background="success_10"
        color="success_100"
        data-testid="publisher-labels.from-owner"
        icon={<SuperAgentIcon />}
      >
        Суперагент
      </Label>
    ),
    [],
  );

  if (tooltip) {
    return (
      <Tooltip
        arrow={false}
        placement="bottom"
        theme="white"
        title={
          <TooltipContent>
            <TooltipContent.List>
              {tooltip.map((item, index) => (
                <TooltipContent.ListItem key={index}>
                  <IconSuccess16 color="success_100" />
                  <UIText2>{item}</UIText2>
                </TooltipContent.ListItem>
              ))}
            </TooltipContent.List>
          </TooltipContent>
        }
      >
        {label}
      </Tooltip>
    );
  }

  return label;
};
